import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import EmbedMessage from '../EmbedMessage';

import './Video.scss';

const Video = ({
    videoUrl,
    image,
    autoplay,
    showMessage,
}) => {

    console.log(showMessage);
    const [play, setPlay] = useState(false);
    const [showMsg, setShowMsg] = useState(showMessage);

    const handleClickPlay = () => { setPlay(true) }

    const NATIVE_VIDEO_FORMATS = ['.mp4', '.webm'];

    const useNativeVideoPlayback = typeof videoUrl !== 'undefined'
        ? NATIVE_VIDEO_FORMATS
            .map(format => videoUrl.endsWith(format))
            .filter(v => !!v)
            .length > 0
        : false;

    const overlayClasses = classNames('Video__Overlay', {
        'Video__Overlay--Active': play,
    });

    return (
        <>
            {image && !showMsg &&
                <div className={overlayClasses}>
                    <img
                        alt="Video"
                        className="Video__Image"
                        src={image}
                    />
                    <div className="Video__Button">
                        <span
                            className="Video__Play"
                            aria-label="Play video"
                            onClick={handleClickPlay}
                        ></span>
                    </div>
                </div>
            }

            {useNativeVideoPlayback &&
                <div className="Video__Native">
                    {!showMsg &&
                        <video
                            src={videoUrl}
                            tabIndex={-1}
                            {...(autoplay
                                ? {
                                    playsInline: true,
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    controls: false
                                }
                                : {
                                    playsInline: false,
                                    autoPlay: false,
                                    muted: false,
                                    loop: false,
                                    controls: false
                                }
                            )}
                        />
                    }
                </div>
            }

            {!useNativeVideoPlayback &&
                <div className="Video__External">
                    {!showMsg &&
                        <ReactPlayer
                            className="Video__Player"
                            width="100%"
                            height="100%"
                            url={videoUrl}
                            {...(autoplay
                                ? {
                                    loop: true,
                                    muted: true,
                                    playsinline: true,
                                    playing: true,
                                    controls: false
                                }
                                : {
                                    loop: false,
                                    muted: false,
                                    playsinline: false,
                                    playing: play,
                                    controls: true
                                }
                            )}
                        />
                    }
                </div>
            }

            {showMsg &&
                <div className="Embed__Message">
                    <EmbedMessage
                        src={videoUrl}
                        hideMessage={() => setShowMsg(false)}
                        showEmbed={() => setShowMsg(true)}
                    />
                </div>
            }
        </>
    );
}

Video.propTypes = {
    videoUrl: PropTypes.string,
    image: PropTypes.string,
    autoplay: PropTypes.number
};

Video.defaultProps = {
    videoUrl: '',
    image: '',
    autoplay: 0
};

export default Video;
